import AccordionDataTransformerBlock, {
    AccordionDataTransformerBlockProps,
} from '@activebrands/core-web/libs/storyblok/content/CmsDataTransformerBlock/AccordionDataTransformerBlock';
import { styled } from '@activebrands/core-web/libs/styletron';
import { BaseModuleProps } from '@activebrands/core-web/types/modules';
import getModuleBottomMarginStyles from '@activebrands/core-web/utils/style-functions/get-module-bottom-margin-styles';

interface AccordionModuleProps extends BaseModuleProps, AccordionDataTransformerBlockProps {}

const SectionWrapper = styled('section', ({ $isGrid }) => ({
    ...getModuleBottomMarginStyles($isGrid),
    padding: '0 var(--margin-content)',
}));

const AccordionModule = ({ isGrid = false, content }: AccordionModuleProps) => {
    return (
        <SectionWrapper $isGrid={isGrid}>
            <AccordionDataTransformerBlock content={content} />
        </SectionWrapper>
    );
};

export default AccordionModule;
